import { supabase } from "./supabase";

const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"];
const MAX_SIZE_BYTES = 2 * 1024 * 1024; // 2MB

const uploadProjectLogo = async ({ userId, projectId, file }) => {
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error("Invalid file type. Use JPEG, PNG, GIF, or WebP.");
  }
  if (file.size > MAX_SIZE_BYTES) {
    throw new Error("File too large (max 2MB).");
  }

  const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, "-");
  const path = `logos/${userId}/${projectId}/${Date.now()}-${safeName}`;

  const { error } = await supabase.storage
    .from("project-logos")
    .upload(path, file, { upsert: true });

  if (error) throw error;

  const { data } = supabase.storage.from("project-logos").getPublicUrl(path);
  return data.publicUrl;
};

export { uploadProjectLogo };
